module.exports = __webpack_public_path__ + "static/media/cornerradius.f23541fa.svg";